import { Outlet } from 'react-router-dom';
import { Footer } from './components/footer';
import { Header } from './components/header';

export function Layout() {
    return (
        <div className="relative z-10 flex min-h-svh w-full flex-col">
            <Header />
            <main className="mx-auto flex w-full max-w-5xl flex-1 flex-col px-6 pb-16 pt-10">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}
